<script>
import dialogMixin from './mixins/dialog'
import { messageSuccess, messageDanger } from '@utils/message'
import formatDate from '@utils/format-date'
import { eventTimeRange, eventSessionTimeTitle } from '@utils/zerone-event'
import { orderRegStatusItem, orderCheckinStatusItem } from '@utils/zerone-order'

export default {
  mixins: [dialogMixin],
  props: {
    detail: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    multipleData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  computed: {
    cancelList() {
      return this.multipleData
    },
    eventTime() {
      return eventSessionTimeTitle(this.multipleData.type, this.multipleData.categoryTitle)
    },
  },
  methods: {
    formatDate,
    confirm() {
      const vm = this
      console.log('vm.multipleData :>> ', vm.multipleData)
      vm.$store
        .dispatch('order/cancelOrder', {
          eventAlias: vm.multipleData.eventalias,
          seriesNum: vm.multipleData.seriesNum,
          uuids: vm.multipleData.uuids,
        })
        .then((res) => {
          if (res.code === 200) {
            vm.dialogMixinDialogVisible = false
            messageSuccess(res.message)
          }
        })
        .catch(() => {
          console.log('catch')
          messageDanger('取消報名失敗')
        })
        .finally(() => {
          setTimeout(() => {
            location.reload()
          }, 500)
        })
    },
    dateTimeRange(item) {
      const timeRange = eventTimeRange({ ...item })
      return timeRange
    },
    checkInItem(date, time, status) {
      let checkinStatus = status
      // if(eventIsEnd(`${ date } ${ time }`) && status === 'CHECKIN') {
      //   checkinStatus = 'NOSHOW'
      // }
      return orderCheckinStatusItem(checkinStatus)
    },
    statusItem(item) {
      return orderRegStatusItem(item)
    },
  },
}
</script>
<template>
  <el-dialog :visible.sync="dialogMixinDialogVisible" :before-close="$DialogMixinOnClose" :custom-class="`${$style.dialogContact} isStyleContact`" width="876px" append-to-body>
    <div class="sectionTitle text-center mb-5 font-medium color-gray-7">取消報名</div>
    <div class="text-base md:text-lg dialogContact__content mb-5 text-md-left text-center">
      <p style="line-height: 2"> 您將取消您所選擇的課程報名，取消後您所佔的名額將會釋出。</p>
      <p class="text-center">確定要取消？</p>
    </div>
    <div class="isStyleOrder box">
      <div v-for="(item, index) in cancelList.sessions" :key="index" :name="index">
        <div v-if="item.session.length !== 0" class="date-box">
          <el-row class="date">
            <el-col>{{ formatDate(item.date, 'yyyy/MM/dd') }}</el-col>
          </el-row>
          <el-row v-for="(innerItem, innerIndex) of item.session" :key="innerIndex" class="time">
            <el-col :span="isMobile ? 24 : 8">
              <div :class="isMobile ? 'mb-2' : ''"> {{ innerItem.startTime }}~{{ innerItem.endTime }} </div>
            </el-col>
            <el-col :span="isMobile ? 24 : 9">
              <div :class="isMobile ? 'mb-2' : ''">{{ innerItem.title }}</div>
            </el-col>
            <el-col :span="isMobile ? 24 : 7">
              <!-- 統一 -->
              <el-tag v-if="multipleData.registrationType === 'impartial'" class="" :class="statusItem(multipleData.regStatus).class">
                {{ statusItem(multipleData.regStatus).title }}
              </el-tag>
              <!-- 多天 -->
              <el-tag v-else class="" :class="statusItem(innerItem.regStatus).class">
                {{ statusItem(innerItem.regStatus).title }}
              </el-tag>
              <!-- 報到 -->
              <el-tag
                v-if="innerItem.regStatus === 'CONFIRMED' || multipleData.regStatus === 'CONFIRMED'"
                class="ml-2"
                :class="checkInItem(item.date, innerItem.endTime, innerItem.checkinStatus).class"
              >
                {{ checkInItem(item.date, innerItem.endTime, innerItem.checkinStatus).title }}
              </el-tag>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <BaseButton class="isStyleNormal isFull isRadius my-5 mx-1" @click="dialogMixinDialogVisible = !dialogMixinDialogVisible"> 取消 </BaseButton>
      <BaseButton class="isStylePrimary isFull isRadius my-5 mx-1" @click="confirm"> 確定 </BaseButton>
    </div>
  </el-dialog>
</template>
<style lang="scss" module>
.dialogContact {
  padding-right: 30px;
  padding-left: 30px;

  :global {
    .dialogContact {
      &__content {
        max-width: 38rem;
        margin: 0 auto;
      }
    }
    .sectionTitle {
      font-size: 24px;
    }
    .tel {
      &:hover,
      &:active {
        color: $color-primary;
        text-decoration: none;
      }
    }
    .date-box {
      border: 1px solid $color-gray-3;
      margin-bottom: 20px;
      .date {
        background-color: #f5f5f5;
        padding: 6px 0 6px 40px;
        font-size: 18px;
        color: $color-gray-6;
      }
      .time {
        padding: 40px 0 40px 20px;
        font-size: 16px;
        color: $color-gray-8;
        border-bottom: 1px solid $color-gray-3;
        margin: 0 20px;
      }
      .time:last-child {
        border-bottom: none;
      }
    }
    .el-dialog__headerbtn {
      right: 40px !important;
    }
  }
}
</style>
